import CheckIcon from '@heroicons/react/20/solid/CheckIcon.js';

import { checkboxStyles } from '../checkbox/checkbox';
import { radioStyles } from '../radio/radio';

/**
 * A card option's selection control, drawn rather than rendered: the option
 * itself is what is chosen and announced, so the Checkbox's (or Radio's) box
 * is borrowed without a second control inside it. Its hover and checked
 * states read the option's group.
 */
export function ChoiceMark({
  isMultiple,
  isSelected,
  className,
}: {
  isMultiple: boolean;
  isSelected: boolean;
  className: string;
}) {
  if (isMultiple) {
    const { box, icon } = checkboxStyles({ size: 'md', variant: 'solid' });
    return (
      <span aria-hidden="true" className={className}>
        <span data-tone="accent" className={box()}>
          {isSelected ? <CheckIcon className={icon()} /> : null}
        </span>
      </span>
    );
  }
  const { box, dot } = radioStyles({ size: 'md', variant: 'solid' });
  return (
    <span aria-hidden="true" className={className}>
      <span data-tone="accent" className={box()}>
        {isSelected ? <span className={dot()} /> : null}
      </span>
    </span>
  );
}
